var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9931 20.1554L18.7931 26.8221L29.1931 13.4888M20.0931 38.8221C17.703 38.8221 15.3364 38.3393 13.1282 37.4012C10.9201 36.4631 8.91375 35.0881 7.22372 33.3548C5.5337 31.6214 4.19309 29.5636 3.27846 27.2989C2.36382 25.0341 1.89307 22.6068 1.89307 20.1554C1.89307 17.7041 2.36382 15.2768 3.27846 13.012C4.19309 10.7473 5.5337 8.68947 7.22372 6.95611C8.91375 5.22275 10.9201 3.84777 13.1282 2.90968C15.3364 1.9716 17.703 1.48877 20.0931 1.48877C24.92 1.48877 29.5492 3.45543 32.9624 6.95611C36.3756 10.4568 38.2931 15.2047 38.2931 20.1554C38.2931 25.1061 36.3756 29.8541 32.9624 33.3548C29.5492 36.8554 24.92 38.8221 20.0931 38.8221Z",
    stroke: "#4ECB71",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    fill: "white",
    transform: "translate(0.593262 0.155273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.da7db384a640ace12b112774607d5fa3.svg";
export { ForwardRef as ReactComponent };